import { required } from '@/services/validations'
import HeadersByBranch from './headersByBranch'
import WhProduct from '@/models/Warehouse/WhProduct'
/* filters */
import Filters from './filters'
export default (branch = [],gBranchOfficeId) => [
    {
        name: 'branch_office_id',
        type: 'select',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Sucursal',
            items: branch,
            //noObject: true,
            // paramSearch: 'name',
            rules: [required],
        },
    },
    {
        name: 'price_sale_selected',
        type: 'tableField',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: HeadersByBranch,
            noActions: true,
            noDataText: 'Sin esquemas.',
            noFilter: false,
            noExport: true,
            noHelper: true,
            noPagination: false,
            noSearch: true,
            persistentData: [
                'new_sale_price',
            ],
            showNativePagination: false,
            //showPicker: true,
            style: {
                //margin: "0 -24px"
            },
            showRemove: false,
            toolbarTitle: 'Detalle modificación precio de venta',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            noRefresh: true,
            mapper: e => {
                //e.activeOffice = Number(gBranchOfficeId)
                e.branchOfficeId = Number(gBranchOfficeId)
                console.log({ gBranchOfficeId })
                return e
            },
            service: WhProduct,
            filters: Filters,
            attachParams:{
              g_branch_office_id: gBranchOfficeId
            }
        },
    },
]
